import React, {useMemo} from 'react';
import {CodeListsGate} from 'services/codelists';
import {
  SceneExtensionsContext,
  useLinkedValueSearchSceneExtensionCore,
  useSceneExtensionsContextProviderValue,
} from 'sceneExtensions';
import {MergeSeriesSceneCore} from './MergeSeriesSceneCore';
import {useCollectionsCodelistIds} from './hooks/useCollectionsCodelistIds';

export const MergeSeriesScene = () => {
  const collectionsCodelistIds = useCollectionsCodelistIds();

  const linkedValueSearchExtension = useLinkedValueSearchSceneExtensionCore({
    canToggleFullWidth: true,
  });
  const extensions = useMemo(
    () => [linkedValueSearchExtension],
    [linkedValueSearchExtension],
  );
  const sceneExtensionContext =
    useSceneExtensionsContextProviderValue(extensions);

  return (
    <CodeListsGate codeLists={collectionsCodelistIds}>
      <SceneExtensionsContext.Provider value={sceneExtensionContext}>
        <MergeSeriesSceneCore />
      </SceneExtensionsContext.Provider>
    </CodeListsGate>
  );
};
